module.exports = __webpack_public_path__ + "static/img/头像1.f22cd6d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/头像1.jpeg
// module id = z7z3
// module chunks = 1